import { slideIndex, slideIndexOnClickAt } from '@/features/spotMapSlice'
import styles from '@/styles/GoogleMap.module.scss'
import React, { useCallback, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import type { MarkerProps } from './types'

const ListPinComponent = memo(
  ({ id, name, address, image, stamp, lat, lng, crowded, campaignType, campaignMapPin }: MarkerProps) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const handleClick = useCallback(
      (e, idx) => {
        dispatch(slideIndex(idx))
        dispatch(slideIndexOnClickAt(new Date().getTime()))
        const cards: NodeListOf<HTMLElement> = document.querySelectorAll('.c-card-all')
        for (const card of cards) {
          card.style.opacity = '0'
        }
        const nextElement: HTMLElement = e.currentTarget.nextElementSibling
        nextElement.style.opacity = '1'
        nextElement.style.zIndex = '20'
        nextElement.style.visibility = 'visible'
      },
      [dispatch],
    )

    const handleHukidashiClick = useCallback((e) => {
      e.currentTarget.style.opacity = 0
      e.currentTarget.style.zIndex = ''
      e.currentTarget.style.visibility = 'hidden'
    }, [])

    return (
      <div className={styles.c_pin_wrap}>
        <div className="pin" onClick={(e) => handleClick(e, id)}>
          <span className="pin_wrap c-thumbnail_min">
            {/* type === 1:スタンプ, type === 2:ポイント */}
            {campaignType === 1 && (
              <>
                {crowded && (
                  <>
                    {crowded === 'FULL' ? (
                      <p className="absolute w-full h-full bg-red-400 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center pt-[4px] text-[16px] text-white">
                        {t('spot_label.full_short', '満')}
                      </p>
                    ) : crowded === 'EMPTY' ? (
                      <p className="absolute w-full h-full bg-blue-400 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center pt-[4px] text-[16px] text-white">
                        {t('spot_label.empty_short', '空')}
                      </p>
                    ) : (
                      <p className="absolute w-full h-full bg-gray-200 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center pt-[6px] text-[16px] text-black">
                        -
                      </p>
                    )}
                  </>
                )}
                {!crowded && (
                  <>
                    {stamp !== null ? (
                      <>
                        {stamp.isHas ? (
                          <img src={stamp.image ? stamp.image : image} alt="" />
                        ) : (
                          <>{image && <img src={image} alt="" />}</>
                        )}
                      </>
                    ) : (
                      <>{image && <img src={image} alt="" />}</>
                    )}
                  </>
                )}
              </>
            )}

            {(campaignType === 2 || campaignType === 3) && (
              <>
                {stamp !== null ? (
                  <>
                    {stamp.isHas ? (
                      <p className="point text-[13px] font-bold">
                        {stamp.earnedPoints >= 99 ? '99+' : stamp.earnedPoints}
                        <span className="text-[10px]">pt</span>
                      </p>
                    ) : (
                      <>{image && <img src={image} alt="" />}</>
                    )}
                  </>
                ) : (
                  <>{image && <img src={image} alt="" />}</>
                )}
              </>
            )}
          </span>
          <style jsx>{`
            .pin {
              position: relative;
              width: 2.5rem;
              margin-top: -2.8rem;
              margin-left: -1.3rem;
            }

            .pin .pin_wrap {
              width: 32px;
              height: auto;
              margin: auto;
              overflow: hidden;
              border-radius: 100%;
              display: block;
            }

            .pin .pin_wrap::before {
              padding-top: calc(20 / 20 * 100%);
            }

            .pin:after {
              position: absolute;
              top: -0.25rem;
              left: 50%;
              z-index: -1;
              width: 100%;
              height: auto;
              padding-top: 130%;
              content: '';
              background-image: url(${campaignMapPin});
              background-repeat: no-repeat;
              background-size: 100%;
              transform: translate(-50%, 0%);
            }

            .pin .point {
              position: absolute;
              width: 100%;
              height: 100%;
              background-color: #fff;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              text-align: center;
              padding-top: 7px;
            }
          `}</style>
        </div>
        <div className={`c-card-all ${styles.c_card}`} onClick={(e) => handleHukidashiClick(e)}>
          <div className="border-gray-200 c-swiper_contents flex items-center border-b py-2">
            <div className="ml-2">
              <p className="text-xsss font-bold">{name}</p>
              <p className="text-xs">{address}</p>
              <a
                href={`https://www.google.com/maps/search/?api=1&map_action=map&query=${lat},${lng}`}
                className={styles.c_google_link}
              >
                {t('spot.open_with_google_map', 'Googleマップで見る')}
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  },
)

ListPinComponent.displayName = 'ListPinComponent'

export default ListPinComponent
